export enum Locations {
    Onboarding = "Onboarding",
    Details = "Details",
    DeleteConfirmation = "Delete Confirmation",
    PortfolioDetails = "Portfolio Details",
    RateCardDetails = "Rate Card Details",
    CustomFieldDetails = "Custom Field Details",
    RateCardsList = "Rate Cards List",
    ActivityTable = "Activity Table",
    TableTab = "Table Tab",
    GanttTab = "Gantt Tab",
    CalendarTab = "Calendar Tab",
    BoardTab = "Board Tab",
    SnapshotsList = "Project Snapshots List",
    SnapshotDetails = "Snapshot Details",
    Gantt = "Gantt",
    PlanningTable = "Planning Table",
    Financials = "Financials",
    ScheduleHours = "Schedule Hour",
    MoreOptions = "More Options",
    Timer = "Timer",
    Assignees = "Assignees",
    Header = "Header",
    Footer = "Footer",
    WorkLoad = "WorkLoad",
    Planning = "Planning",
    Simulation = "Simulation",
    Grid = "Grid",
    Categories = "Categories",
    Calendars = "Calendars",
    Priorities = "Priorities",
    VacationTypes = "Vacation Types",
    PublicHolidays = "Public Holidays",
    PortfolioStatuses = "Portfolio Statuses",
    ManageApps = "Manage Apps",
    JiraSettings = "Jira Settings",
    ReportDetails = "Report Details",
    Dashboard = "Dashboard",
    TimelogsAddTime = "Add Time",
    TimelogsHistory = "Time Logs History",
    EmptyList = "No Data View",
    GridHeaderMenu = "Table Header Menu",
    AppMenu = "App Menu",
    FiltersPanel = "Filters Panel",
    BatchOperations = "Batch Operations",
    AccountSettingsTimeTrackingPolicy = "Time Tracking Policy",
    AccountSettingsResourceApproval = "Planning",
    AccessLevelDetails = "Access Level Details",
    SpaceSettings = "Space Settings",
    SpaceSettingsMembers = "Members",
    UserDetails = "User Details",
    InvoiceSettings = "Invoice Settings",
    InvoiceItemsGrid = "Items Grid",
    InvoiceTimeEntriesDialog = "Time Entries Dialog",
    InvoiceExpensesDialog = "Expenses Dialog",
    InvoiceFlatFeeTasksDialog = "Flat Fee Tasks Dialog",
    InvoiceSendByEmailDialog = "Invoice Send By Email Dialog",
}
